module.exports = FormData;


//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-form-data/lib/browser.js
// module id = 809
// module chunks = 0